(function() {
    'use strict';

    angular.module('process', [
            'ui.router',

            'process.constants',
            'process.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'processPermissionsConst', 'processstagePermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, processPermissionsConst, processstagePermissionsConst) {
        $stateProvider
            .state('layout.process', {
                abstract: true,
                url: '/processes',
                data: {
                    title: 'Procesy',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.process.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/process/views/process-list/process-list.html',
                        controller: 'ProcessListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: processPermissionsConst.view
                }
            })
            .state('layout.process.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/process/views/process-create/process-create.html',
                        controller: 'ProcessCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: processPermissionsConst.add
                }
            })
            .state('layout.process.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/process/views/process-update/process-update.html',
                        controller: 'ProcessUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: processPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.productionCube', {
                abstract: true,
                url: '/cubes',
                data: {
                    title: 'Kostki produkcyjne',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.productionCube.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/process/views/production-cube-list/production-cube-list.html',
                        controller: 'ProductionCubeListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: processstagePermissionsConst.view
                }
            })
            .state('layout.productionCube.details', {
                url: '/details/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/process/views/production-cube-details/production-cube-details.html',
                        controller: 'ProductionCubeDetailsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: processstagePermissionsConst.view
                }
            });
    }
})();
